var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVariableVideo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 48,
    viewBox: "0 0 70 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "variable-video-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M64.0238 39.5536L43.1992 26.5195V19.5957L63.1366 7.11675L64.0238 6.56157C65.3092 5.75688 66.9998 6.65561 66.9998 8.14362V36.0909C66.9998 39.2851 65.3092 40.3582 64.0238 39.5536Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M64.0238 37.6748L43.1992 24.6406V28.402L64.0238 41.4362C65.3092 42.2409 66.9998 41.3422 66.9998 39.8541V36.0927C66.9998 37.5807 65.3092 38.4793 64.0238 37.6748Z",
    fill: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M51.1335 6.76141C51.1335 4.69263 49.3951 3 47.2703 3H6.86324C6.41214 3 5.97882 3.07698 5.57551 3.21691L4.93164 43.1183L50.9107 42.4914C51.0546 42.0987 51.1335 41.6768 51.1335 41.2376V6.76141Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.57546 40.6125V3.21875C4.07899 3.73807 3 5.13368 3 6.76312V41.2394C3 43.3082 4.73844 45.0008 6.86319 45.0008H47.2703C48.9439 45.0008 50.3773 43.9503 50.9107 42.4932H7.50706C6.44468 42.4932 5.57546 41.6469 5.57546 40.6125Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5852 14.3555V14.3549C20.6132 14.0147 19.5161 14.706 19.5161 15.7803V32.5737C19.5161 33.769 20.8744 34.4911 21.907 33.8447L35.3223 25.448C35.7617 25.173 35.9953 24.7358 36.0283 24.2866L36.0281 24.2867C36.0663 23.7646 35.8328 23.2263 35.3221 22.9066L21.9068 14.5099C21.8024 14.4446 21.6945 14.3938 21.5852 14.3555Z",
    fill: "#DCE6EB"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 346",
    d: "M1 5V43C1 45.2091 2.79086 47 5 47H49.045C51.2541 47 53.045 45.2091 53.045 43V37.9071C53.045 37.1007 53.9504 36.626 54.6136 37.0846L61 41.5L65.0837 44.3075C66.7424 45.4479 69 44.2604 69 42.2474V6.01736C69 4.05235 66.8373 2.85548 65.1723 3.89904L54.576 10.5404C53.91 10.9578 53.045 10.4791 53.045 9.69306V5C53.045 2.79086 51.2541 1 49.045 1H5C2.79086 1 1 2.79086 1 5Z",
    stroke: "#C6C6C6",
    strokeLinecap: "square",
    strokeDasharray: "4 4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVariableVideo);
export default __webpack_public_path__ + "static/media/variableVideo.c307c9b2407be3079f121cf03b0d01e5.svg";
export { ForwardRef as ReactComponent };